export enum Routes {
  Setting_Billing_Upgrade_Plan = '/billing/upgrade-plan',
  Setting_Billing_Upgrade_Email_Outreach_Plan = '/billing/upgrade-plan/email-outreach',
  Setting_Billing_Upgrade_Lead_Finder_Plan = '/billing/upgrade-plan/lead-finder',
  Setting_Billing_Upgrade_Plan_BFCM = '/billing/upgrade-plan-bfcm',
  Setting_Billing_Upgrade_Email_Outreach_Plan_BFCM = '/billing/upgrade-plan-bfcm/email-outreach',
  Setting_Billing_Add_Credits = '/billing/subscriptions/lead-finder#lead-finder-credit-plans',
  Setting_Billing_Inbox_Placement_Radar = '/billing/upgrade-plan/inbox-placement-radar',
  Setting_Billing_Upgrade_Dialer_Plan = '/billing/upgrade-plan/dialer',
  Setting_Billing_Sending_Infrastructure = '/billing/subscriptions/sending-infrastructure',

  Leads_Finder_Company = '/v2/leads/company/total',
  Inbox_Radar_Main_Page = '/inbox-radar',
  CSV_Enrichment = '/v2/leads/csv-enrichment',
  CSV_Enrichment_New = '/v2/leads/csv-enrichment/new',
  CSV_Enrichment_Status = '/v2/leads/csv-enrichment/status',
  Email_Infra_Pay = '/email-infra/pay',
  Design_System = '/design-system',
}
